import { __decorate } from "tslib";
import { css, html, LitElement } from 'lit';
import { classMap } from 'lit/directives/class-map.js';
import { customElement, property, state } from 'lit/decorators.js';
let ViedocDrawer = class ViedocDrawer extends LitElement {
    constructor() {
        super(...arguments);
        this._hidden = true;
        this.closeLabel = 'Close';
        this.open = false;
    }
    willUpdate(changedProperties) {
        if (changedProperties.has('open')) {
            if (this.open) {
                this._hidden = false;
            }
        }
    }
    _handleCloseClick() {
        this.open = false;
    }
    _handleTransitionEnd() {
        if (!this.open) {
            this._hidden = true;
        }
    }
    render() {
        const classNames = classMap({
            drawer: true,
            'drawer--open': this.open,
            'drawer--hidden': this._hidden,
        });
        return html `<div class=${classNames}>
      <div
        class="drawer__overlay"
        @click=${this._handleCloseClick}
        role="presentation"
      ></div>
      <nav
        class="drawer__content"
        tabIndex="-1"
        @transitionEnd=${this._handleTransitionEnd}
      >
        <button
          class="drawer__close-button"
          @click=${this._handleCloseClick}
          aria-label=${this.closeLabel}
        >
          <div class="drawer__close-icon">
            <viedoc-icon name="close"></viedoc-icon>
          </div>
        </button>
        <div class="drawer__scroll-content">
          <slot></slot>
        </div>
      </nav>
    </div>`;
    }
};
ViedocDrawer.styles = [
    css `
      .drawer {
        font-family: var(--font-family-monument);
        pointer-events: none;
        position: fixed;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        z-index: 100;
      }

      .drawer--open {
        pointer-events: auto;
      }

      .drawer--hidden {
        visibility: hidden;
      }

      .drawer__overlay {
        opacity: 0;
        transition: opacity 500ms;
        background: rgba(0, 0, 0, 0.6);
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
      }

      .drawer--open .drawer__overlay {
        opacity: 1;
      }

      .drawer__content {
        transform: translateX(100%);
        transition: transform 500ms;
        width: 100%;
        background: var(--primary-background-color);
        color: var(--primary-text-color);
        margin-left: auto;
        height: 100%;
        padding: 2rem 0 3rem;
        display: flex;
        flex-direction: column;
      }

      .drawer--open .drawer__content {
        transform: translateX(0);
      }

      [dir='rtl'] .drawer__content {
        transform: translateX(-100%);
        margin-left: 0;
        margin-right: auto;
      }

      .drawer__content:focus-visible {
        outline: none;
      }

      @media (min-width: 48rem) {
        .drawer__content {
          width: 488px;
        }
      }

      .drawer__scroll-content {
        flex-grow: 1;
        overflow-y: auto;
        overflow-x: hidden;
        display: flex;
        flex-direction: column;
        -ms-overflow-style: none; /* IE and Edge */
        scrollbar-width: none; /* Firefox */
        margin-bottom: 5rem;
      }

      .drawer__scroll-content::-webkit-scrollbar {
        display: none; /* Chrome, Safari and Opera */
      }

      .drawer__close-button {
        background: none;
        border: none;
        cursor: pointer;
        color: inherit;
        margin-bottom: 2rem;
        align-self: flex-start;
        transition: color 200ms;
        padding: 0;
        padding-right: clamp(1.5rem, 3.33vw, 3rem);
        padding-left: clamp(1.5rem, 3.33vw, 3rem);
      }

      .drawer__close-button:hover {
        color: var(--color-gray-40);
      }

      .drawer__close-icon {
        height: 2rem;
        width: 2rem;
      }
    `,
];
__decorate([
    state()
], ViedocDrawer.prototype, "_hidden", void 0);
__decorate([
    property({ type: String, attribute: 'close-label' })
], ViedocDrawer.prototype, "closeLabel", void 0);
__decorate([
    property({ type: Boolean, reflect: true })
], ViedocDrawer.prototype, "open", void 0);
ViedocDrawer = __decorate([
    customElement('viedoc-drawer')
], ViedocDrawer);
export { ViedocDrawer };
